export interface CookieOptions {
  days?: number;
  path?: string;
}

/**
 * Get a cookie value by name
 */
export const getCookie = (name: string): string | undefined => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop()?.split(';').shift();
  return undefined;
};

/**
 * Set a cookie with the given name and value
 */
export const setCookie = (name: string, value: string, options: CookieOptions = {}): void => {
  const { days, path = '/' } = options;
  let expires = '';
  
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = `; expires=${date.toUTCString()}`;
  }
  
  document.cookie = `${name}=${value}${expires}; path=${path}`;
};
